import { type CommonAction, success } from "@iflyrpa/share";
import { z } from "zod";
import type { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { DisabledReq } from "../../types";
import { Http } from "../../utils/http";

export const UnreadCountSchema = z.object({
    connections: z.number().nullable(),
    mentions: z.number().nullable(),
    unread_count: z.number().nullable(),
    likes: z.number().nullable(),
});

export type UnreadCount = z.infer<typeof UnreadCountSchema>;

export type PublishAction = CommonAction<ActiomCommonParams, UnreadCount>;

export const getXhsUnreadCount: PublishAction = async (_task, params) => {
    if (DisabledReq) return success({ connections: 0, mentions: 0, unread_count: 0, likes: 0 }, "获取未读消息数成功");
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://www.xiaohongshu.com/",
        origin: "https://www.xiaohongshu.com",
    };
    const args: AxiosProxyParams = [
        { headers },
        _task.logger,
        params.proxyLoc,
        params.localIP,
        // params.huiwenToken,
        params.accountId,
    ];
    const http = new Http(...args);

    let unreadCount: UnreadCount = {
        connections: null,
        mentions: null,
        unread_count: null,
        likes: null,
    };

    const res = await http.api<{ code: number; msg: string; data: UnreadCount }>(
        {
            method: "get",
            url: "https://edith.xiaohongshu.com/api/sns/web/unread_count",
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );

    const isSuccess = res.code === 0;
    if (isSuccess) unreadCount = res.data;
    const message = `获取未读消息数${isSuccess ? "成功" : `失败，原因：${res.msg}`}${_task.debug ? ` ${http.proxyInfo}` : ""}`;

    // return response(isSuccess ? 0 : 414, message, unreadCount);
    return success(unreadCount, message);
};
